import React, { useState, useRef } from 'react';
import Layout from '../components/layout';
import { graphql, Link } from 'gatsby';
import Video from '../components/video';
import styled from 'styled-components'
import ArtDirectedFullBackground from '../components/ArtDirectedFullBackground'
import { Burger, Menu } from '../components';
import MaxLogo from 'assets/images/3dsmax-logo.svg';
import MayaLogo from 'assets/images/maya-logo.svg';
import SPLogo from 'assets/images/substance-painter-logo.svg';
import ZBrushLogo from 'assets/images/zbrush-logo.png';
import UnityLogo from 'assets/images/unity-logo.png';
import CadLogo from 'assets/images/autocad-logo.png';
import ArnoldLogo from 'assets/images/arnold-logo.png';
import { device } from 'helpers/breakpoints';


import NextIcon from 'assets/icons/chevron-right.svg';



const IntroWrapper = styled.div`
display: grid;
grid-template-columns: 3fr 2fr
margin-bottom: 2rem;
align-items : center;
grid-gap:10px;

@media ${device.tablet} {
  grid-template-columns: 5fr 3fr
}

@media ${device.laptopL} {
  grid-template-columns: 5fr 2fr
}
`

const LogoImg = styled.div`
align-self: center;
display: flex;
justify-content: flex-end;
flex-wrap: wrap;

img:first-child {
  margin-left: 0!important;
}
img {
  margin: 0 0 10px 10px;
  max-height: 50px;
  width: auto;

  @media ${device.tablet} {
  margin: 0 0 15px 15px;
     max-height: 75px;
  }

  @media ${device.laptop} {
    max-height: 100px;
    margin: 0 0 20px 20px;
  }
}
`
const TitleWrapper = styled.h1`
display: flex;
flex-direction: column;

  span:first-child{
    align-self: flex-start;
    font-weight: bold;
    color:var(--color-accent);
    @media ${device.mobileMax} {
      font-size: 2.5rem;
    }
  }

  @media ${device.laptop} {
    display: grid;
    grid-template-columns: 80px auto;
  }
`

const DescriptionWrapper = styled.div`
  margin: 1rem 0;

  @media ${device.laptop} {
    display: grid
    grid-template-columns: 5fr 1fr;
    margin: 2rem 0;
  }
`

const ContentWrapper = styled.div`
  margin-top: 1rem;
  margin-bottom: 4rem;
  padding-left:1rem;
  padding-right:1rem;

  @media ${device.laptopL} {
    margin-top: 3rem;
    padding-left:0;
    padding-right:0;
    margin-bottom: 8rem;
  }

`

const NextVideo = styled.div `
  display: flex;
  justify-content: flex-end;

  a.btn__icon svg {
   width: 10px;
   margin-left: 15px;
 }
`

const VideoWrapper = styled.div `
  margin-bottom: 2rem;

  @media ${device.laptopL} {
    margin-bottom: 5rem;
  }
`

const MenuWrapper = styled.div `
  position: relative;
`

export default function Template({
  data
}) {
  const [open, setOpen] = useState(false);
  const node = useRef();
  const menuId = "main-menu";
  const { markdownRemark, allMarkdownRemark, mayaPosts, mayaCAPosts, mayaUKPosts, maxPosts, maxCAPosts, maxUKPosts, course001Posts, course002Posts, course003Posts, course004Posts, course005Posts, course006Posts, course007Posts, course008Posts, desktop, medium, small  } = data; // data.markdownRemark holds your post data
  const { frontmatter, fields } = markdownRemark;

  const postID = frontmatter.id;
  const postSection = frontmatter.section;
  const postDescription = frontmatter.description;

  let logos;
  let menuItems;
  let home;
  let postAssetsURL;

  if (postID == "3dsmax") {
    logos = [MaxLogo];
    menuItems = maxPosts;
    home = "/3dsmax-intro";
    postAssetsURL = 'https://area-resources-prd.autodesk.com/downloads/Intro3dsMax-2021_ProjectFiles.zip';
  }
  else if (postID == "3dsmax-ca") {
    logos = [MaxLogo];
    menuItems = maxCAPosts;
    home = "/3dsmax-intro-ca";
    postAssetsURL = 'https://area-resources-prd.autodesk.com/downloads/Intro3dsMax-2021_ProjectFiles.zip';
  }
  else if (postID == "3dsmax-uk") {
    logos = [MaxLogo];
    menuItems = maxUKPosts;
    home = "/3dsmax-intro-uk";
    postAssetsURL = 'https://area-resources-prd.autodesk.com/downloads/Intro3dsMax-2021_ProjectFiles.zip';
  }
  else if (postID == "maya-ca") {
    logos = [MayaLogo];
    menuItems = mayaCAPosts;
    home = "/maya-intro-ca";
    postAssetsURL = 'https://area-resources-prd.autodesk.com/downloads/IntroMaya-2020_ProjectFiles.zip';
  }
  else if (postID == "maya-uk") {
    logos = [MayaLogo];
    menuItems = mayaUKPosts;
    home = "/maya-intro-uk";
    postAssetsURL = 'https://area-resources-prd.autodesk.com/downloads/IntroMaya-2020_ProjectFiles.zip';
  }
  else if (postID == "001-creature-texturing-for-film") {
    logos = [MayaLogo, SPLogo];
    menuItems = course001Posts;
    home = "/001-creature-texturing-for-film";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/projectfiles_creaturemodeling_film.zip';
  }
  else if (postID == "002-realtime-creature-rigging") {
    logos = [MayaLogo];
    menuItems = course002Posts;
    home = "/002-realtime-creature-rigging";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/projectfiles_creaturemodeling_film.zip';
  }
  else if (postID == "003-creature-modeling-for-film-with-maya-and-zbrush") {
    logos = [MayaLogo, ZBrushLogo];
    menuItems = course003Posts;
    home = "/003-creature-modeling-for-film-with-maya-and-zbrush";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/projectfiles_creaturemodeling_film.zip';
  }
  else if (postID == "004-creature-texturing-for-games") {
    logos = [MayaLogo, SPLogo, UnityLogo];
    menuItems = course004Posts;
    home = "/004-creature-texturing-for-games";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/projectfiles_creaturemodeling_film.zip';
  }
  else if (postID == "005-creature-modeling-for-games") {
    logos = [MayaLogo, ZBrushLogo];
    menuItems = course005Posts;
    home = "/005-creature-modeling-for-games";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/projectfiles_creaturemodelinggames-005.zip';
  }
  else if (postID == "006-creature-concepting-with-maya-and-zbrush") {
    logos = [MayaLogo, ZBrushLogo];
    menuItems = course006Posts;
    home = "/006-creature-concepting-with-maya-and-zbrush";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/projectfiles_creatureconcept-004.zip';
  }
  else if (postID == "007-creating-an-archviz-scene-autocad-to-3ds-max-workflow") {
    logos = [CadLogo, MaxLogo];
    menuItems = course007Posts;
    home = "/007-creating-an-archviz-scene-autocad-to-3ds-max-workflow";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/archviz%20assets.zip';
  }
  else if (postID == "008-product-viz-from-cad-model-to-final") {
    logos = [MaxLogo, ArnoldLogo];
    menuItems = course008Posts;
    home = "/008-product-viz-from-cad-model-to-final";
    postAssetsURL = 'https://areadownloads.autodesk.com/wdm/courses/projectfiles-product_viz.zip';
  }
  else {
    logos = [MayaLogo];
    menuItems = mayaPosts;
    home = "/maya-intro";
    postAssetsURL = 'https://area-resources-prd.autodesk.com/downloads/IntroMaya-2020_ProjectFiles.zip';
  }

    const listLogos = logos.map((logo) =>
        <img src={logo} />
    )

  const getNextItem = () => {
    let currentItemSlug = fields.slug;
    let nextItem;
    let lastItem = menuItems.edges.slice(-1)[0].node.fields.slug;

    menuItems.edges.map((item, index) => {
      let itemSlug = item.node.fields.slug;
      if(currentItemSlug ==  itemSlug){
          if (itemSlug == lastItem) {
            nextItem  = null
          }
          else {
            nextItem =  item.next.fields.slug
          }
      }
    })

    return(nextItem)
  }

  const videoThumbnailURL = frontmatter.videoThumbnailURL ? frontmatter.videoThumbnailURL.childImageSharp.fixed.src : ''

  return (
    <>
    <MenuWrapper ref={node}>
      <Burger open={open} setOpen={setOpen} aria-controls={menuId} />
      <Menu open={open} setOpen={setOpen} id={menuId} currentItem={frontmatter.slug} postID={postID} postSection={postSection} postHome={home} postAssetsURL={postAssetsURL} postMenu={{...menuItems}}/>
    </MenuWrapper>

    <ArtDirectedFullBackground halfBG={true} desktopBG={data.desktop} mediumBG={data.medium} smallBG={data.small}>
      <Layout title = {`${postSection} | ${frontmatter.cleanTitle}`} imgURL={videoThumbnailURL}  pageDescription={postDescription}>
        <div className="container">
          <ContentWrapper>

            <IntroWrapper>
              <TitleWrapper>
                    <span>{frontmatter.position}</span>
                    <span>{frontmatter.cleanTitle}</span>
              </TitleWrapper>
              <LogoImg>
                {/*<Link to={home}>
                  <img src={logo} alt={`Autodesk ${postSection}`} />
                </Link>*/}
                {listLogos}
              </LogoImg>
            </IntroWrapper>

            <VideoWrapper>
              <Video videoSrcURL={frontmatter.videoSourceURL} />

            </VideoWrapper>


            <DescriptionWrapper>
              {/*<div>{frontmatter.description}</div>*/}
              <div dangerouslySetInnerHTML={{__html: frontmatter.description }} />
              <div>
                {getNextItem() == null ? null :  <NextVideo><Link className="btn__icon btn__icon--chevron btn--ghost btn__cta " to={getNextItem()} data-wat-link="true" data-wat-val="Next Lesson" data-wat-loc={fields.slug}>Next Lesson <NextIcon/></Link></NextVideo> }
              </div>
            </DescriptionWrapper>


          </ContentWrapper>
        </div>
      </Layout>
    </ArtDirectedFullBackground>
    </>
  );
}


export const pageQuery = graphql`
  query($slug: String!) {
    desktop: file(relativePath: { eq: "images/video-page-bg.jpg" }) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    medium: file(relativePath: { eq: "images/video-page-bg.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1400, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    small: file(relativePath: { eq: "images/video-page-bg.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 490, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }


    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        slug
        title
        videoSourceURL
        videoThumbnailURL {
          childImageSharp {
           fixed {
            src
          }
          }
        }
        description
        cleanTitle
        position
        section
        id
      }
      fields {
        slug
      }
    }

    maxPosts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"3dsmax"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    maxCAPosts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"3dsmax-ca"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }

    maxUKPosts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"3dsmax-uk"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }

    mayaPosts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"maya"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    mayaCAPosts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"maya-ca"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    mayaUKPosts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"maya-uk"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }

    course001Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"001-creature-texturing-for-film"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    course002Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"002-realtime-creature-rigging"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }

    course003Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"003-creature-modeling-for-film-with-maya-and-zbrush"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }

    course004Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"004-creature-texturing-for-games"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    course005Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"005-creature-modeling-for-games"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    course006Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"006-creature-concepting-with-maya-and-zbrush"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    course007Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"007-creating-an-archviz-scene-autocad-to-3ds-max-workflow"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }


    course008Posts: allMarkdownRemark(sort: {order: ASC, fields: frontmatter___position}, filter: {frontmatter: {id: {eq:"008-product-viz-from-cad-model-to-final"}}})  {
      edges {
        next {
          fields {
            slug
          }
        }
        node {
          fields {
            slug
          }
          frontmatter {
            slug
            title
            cleanTitle
            position
            section
            id
          }
        }
      }
    }



  }
`;

